const middlewareErrorName = 'ContextMiddlewareError';
class ContextMiddlewareError extends Error {
  constructor(err) {
    super(err);
    this.name = middlewareErrorName;
    this.isError = err instanceof Error;
  }
}
const next = msg => {
  throw new ContextMiddlewareError(msg);
};
function flatDeep(arr, d = 1) {
  return d > 0 ? arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val), []) : arr.slice();
}
async function withCtxMiddleware(ctxMiddleware = [], ctx) {
  // ensure we have an array of context middleware to iterate
  const ctxMiddlewareQueue = flatDeep([...ctxMiddleware], Infinity);

  // assign a data object to ctx to ensure a location to store middleware output
  if (!ctx.data) {
    ctx.data = {};
  }

  // assign a metadata store
  if (!ctx.__middleware) {
    ctx.__middleware = {};
  }

  // store the original query in ctx if it hasn't been already
  if (!ctx.originalQuery) {
    ctx.originalQuery = {
      ...ctx.query
    };
  }

  // assign a handler to ctx that will allow the (re)assignment of metadata for individual middleware
  if (!ctx.registerMiddleware) {
    ctx.registerMiddleware = (name, metadata = {}) => {
      ctx.__middleware[name] = metadata;
    };
  }

  // We want all middleware to run each async action in sequence to preserve middleware order.
  // eslint-disable-next-line no-restricted-syntax
  const queueLength = ctxMiddlewareQueue.length;
  for (let i = 0; i < queueLength; i += 1) {
    const middleware = ctxMiddlewareQueue[i];
    try {
      if (typeof middleware === 'function') {
        // eslint-disable-next-line no-await-in-loop
        await middleware(ctx, next);
      }
    } catch (err) {
      if (err.name === middlewareErrorName) {
        if (err.isError) {
          // rethrow original error
          throw err;
        } else {
          // allow next method calls with no message to skip to next middleware in the queue
          if (!err.message) {
            // eslint-disable-next-line no-continue
            continue;
          }
          if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.log(`[ContextMiddleware]: ${err.message}`);
          }
        }
        break;
      } else {
        // rethrow original error
        throw err;
      }
    }
  }
}

export { withCtxMiddleware };
